import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../login/login.css";
import { userLogin } from "../../hooks/api/utils";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.email || !form.password) return;
    setLoading(true);
    const payload = {
      ...form,
      user_type: 1, // static as per your CURL
    };
    userLogin(payload, setLoading, navigate, "/dashboard");
  };

  return (
    <div className="main-container">
      <div className="main-content">
        <section className="form_part space-cmn">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="signupTab">
                  <div className="formArea loginmain">
                    <form onSubmit={handleSubmit}>
                      <div className="row g-4">
                        <div className="col-md-12">
                          <div className="d-flex justify-content-center align-items-center">
                            <h4 className="fs-3 fw-bold">Login</h4>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Email</label>
                            <input
                              type="email"
                              name="email"
                              className="form-control"
                              placeholder="Enter your email"
                              value={form.email}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group position-relative">
                            <label>Password</label>
                            <input
                              type={showPassword ? "text" : "password"}
                              name="password"
                              className="form-control"
                              placeholder="Enter your password"
                              value={form.password}
                              onChange={handleChange}
                              required
                            />
                            <span
                              onClick={() => setShowPassword(!showPassword)}
                              className="eye-icon"
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <a href="/forgot-password" className="forgot">
                            Forgot Password?
                          </a>
                        </div>
                        <div className="col-md-12">
                          <button
                            type="submit"
                            className="black_btn"
                            disabled={loading}
                          >
                            {loading ? "Logging in..." : "Log In"}
                          </button>
                        </div>

                        {/* <div className="co-md-12">
                      <div className="divider"><p>OR</p></div>
                    </div> */}

                        {/* <div className="col-md-12">
                      <div className="social">
                        <a href="#"><img src="images/google.webp" className="img-fluid" alt="Google" /> Continue with Google</a>
                        <a href="#"><img src="images/apple.png" className="img-fluid" alt="Apple" /> Continue with Apple</a>
                      </div>
                    </div> */}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Login;
